module.exports = __webpack_public_path__ + "media/images/bt-intermunicipal-clicdo-f2795fc39e1150b9f84a360c00a27b79.svg";